import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { discountPlanConfig } from "@/lib/datasetRegistry"

// Thin config module — the whole page is the parameterized <DatasetUploadsPage>
// driven by `discountPlanConfig` (app/frontend/lib/datasetRegistry.ts). The
// controller renders this via inertia page name "admin/discount_plan/Uploads".
export default function AdminDiscountPlanUploads(props: Omit<DatasetUploadsPageProps, "config">) {
  return <DatasetUploadsPage config={discountPlanConfig} {...props} />
}
